import { Component } from "./Component.js";
export class TypedDataComponent extends Component {
    /**
     * wraps setData, but uses the type of ComponentStoredData to allow for static type checking
     *
     * @param path see setData path parameter
     * @param newValue see setData newValue parameter
     * @param setMode see setData setMode parameter
     * @param clone see setData clone parameter
     */
    setTypedData(path, newValue, setMode, clone) {
        this.setData(path, newValue, setMode, clone);
    }
    /**
     * wraps getData, but uses the type of ComponentStoredData to allow for static type checking
     *
     * @param path see getData path parameter
     * @param default set getData default parameter
     * @returns value at path as resolved by getData
     */
    getTypedData(path, defaultValue) {
        return this.getData(path, defaultValue);
    }
    /**
     * wraps removeData, but uses the type of ComponentStoredData to allow for static type checking
     *
     * @param path see removeData path parameter
     * @param destroyEvents see removeData destroyEvents parameter
     * @param destroyChildEvents see removeData destroyChildEvents parameter
     */
    removeTypedData(path, destroyEvents = false, destroyChildEvents = false) {
        this.removeData(path, destroyEvents, destroyChildEvents);
    }
}
//# sourceMappingURL=TypedDataComponent.js.map